import { style as globalStyle } from '@/styles/globals';
import RoomIcon from '@mui/icons-material/Room';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@mui/styled-engine';
import Box from '@mui/system/Box';
import { useState } from 'react';
import Select, { components, ControlProps } from 'react-select';
import { clearPoints } from '../../../slices/area/slices/searchFlightFormSlice';
import { useAppDispatch, useAppSelector } from '../../../utils/hook';
import SearchDialog from '../SearchDialog';
import type { ISearchFromInputParams } from '../SearchDialog/index.d';
import { pr } from '@/utils/pxToRem';
import { isEmpty } from 'lodash';
import { removeVietnameseTones } from '@/utils/stringConvert';

export const Headline = styled('p')`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.25px;
  margin-bottom: 0;
  margin-top: 0;
  word-break: break-word;
`;

export const Caption = styled('p')`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.1px;
  margin-bottom: 0;
  word-break: break-word;
`;

export const Airport = styled('p')`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.1px;
  margin-bottom: 0;
  word-break: break-word;
  margin-top: 0px;
`;

export const Container = styled('div')`
`;

const SearchFormInput = ({
  isTrain,
  type,
  isDesktop,
  miniSeo,
  lang,
  point,
  isGetFromSeo,
  onOpenSearchDialog,
}: ISearchFromInputParams) => {
  const [name, setName] = useState('');
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const { startPointHome, toPointHome } = useAppSelector((store) => store.searchFlightForm);
  let areaPoint;
  if (isGetFromSeo) {
    areaPoint = point;
  } else {
    areaPoint = type === 'from' ? startPointHome : toPointHome;
  }
  // let areaPoint = type === 'from' ? startPointHome : toPointHome;

  const label = type === 'from' ? (lang?.SearchBar?.flightsTab?.fromMobile || 'Nơi xuất phát') : (lang?.SearchBar?.flightsTab?.toMobile || 'Nơi đến');
  const placeholder = type === 'from' ? (lang?.SearchBar?.flightsTab?.fromMobile || 'Nơi xuất phát') : (lang?.global?.whereGo || 'Bạn muốn đi đâu?');

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClose = () => {
    setOpen(false);
  };

  const inputValue = {
    location: '',
    airport: '',
  };
  if (!isEmpty(areaPoint) && areaPoint) {
    if (!isTrain) {
      if (areaPoint?.airports?.length > 1) {
        inputValue.location = `${areaPoint.location}`;
        inputValue.airport = `${areaPoint.airports.length} ${lang?.global?.airports || 'sân bay'}`;
        areaPoint?.airports?.forEach((airport: any) => {
          inputValue.airport += ` - ${airport.airportCode}`;
        });
      } else {
        inputValue.location = `${areaPoint.location}`;
        inputValue.airport = `${areaPoint.airports?.[0]?.airportCode} - ${lang?.lang === 'en' ? areaPoint.airports?.[0]?.nameEn : areaPoint.airports?.[0]?.nameVn}`;
      }
    } else {
      inputValue.location = `${areaPoint.location}`;
      inputValue.airport = `${areaPoint.train_stations?.[0]?.code} - ${lang?.lang === 'en' ? areaPoint.train_stations?.[0]?.name : areaPoint.train_stations?.[0]?.name}`;
    }
  }

  return (
    <>
      <Container
        className="search-widget-home from-select"
        // id="from-select"
        style={{
          paddingRight: '12px',
          paddingBottom: type === 'from' ? '10px' : '0px',
        }}
        onClick={() => {
          if (onOpenSearchDialog) {
            onOpenSearchDialog();
          }
          setOpen(true);
        }}
      >
        {inputValue.location
          ? (
            <div>
              {!miniSeo && (
              <Caption className="color--medium-sub">
                {label}
              </Caption>
              )}

              <Headline className="to-name color--darkness">
                {lang?.lang === 'en' ? removeVietnameseTones(inputValue?.location) : inputValue?.location}
              </Headline>
              {!miniSeo && (
              <Airport
                className="color--medium-sub"
              >
                {inputValue?.airport}
              </Airport>
              )}
            </div>
          )
          : (
            <Headline className="color--light-disable">
              {placeholder}
            </Headline>
          )}
      </Container>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="body"
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <SearchDialog
          isTrain={isTrain}
          lang={lang}
          type={type}
          setClose={() => {
            setOpen(false);
          }}
        />
      </Dialog>
    </>
  );
};

const StyledBox = styled(Box)((props: any) => ({
  background: '#21212114',
  borderRadius: props?.isDesktop ? pr`6px` : pr`16px`,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'flex-end',
  marginBottom: pr`8px`,
}));

const StyledTypography = styled(Typography)({
  // fontWeight: 'bold',
  fontSize: '1rem',
  lineHeight: 'unset',
});

const IndicatorSeparator = () => <></>;

const DropdownIndicator = () => <></>;

export default SearchFormInput;
